
import React, {useState, useEffect} from "react";
import { useInView } from 'react-intersection-observer';
import { motion } from "framer-motion";
import './styles.css'

const placeholderVariants ={
    initial: {
      opacity: 0,
    },
    animate: {
        opacity: 1,
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0.45,
            ease: [0.33, 1, 0.68, 1]
        }
    }
}

const fullImgVariants ={
    initial: {
      opacity: 0,
      filter: 'blur(15px)',
    },
    animate: {
        opacity: 1,
        filter: 'blur(0px)',
        transition: {
            duration: 0.65,
            ease: [0.33, 1, 0.68, 1]
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0.65,
            ease: [0.33, 1, 0.68, 1]
        }
    }
}

const imgWrapperVariants = {
    initial: (i) => ({
        opacity: i[0] || i[2] ? 0 : 1,
        transform: i[4] ? "translate3d(0, 0x, 0) scale3d(1, 1, 1)" 
                        : i[3] ? "translate3d(0, 100px, 0) scale3d(1, 1.2, 1)" 
                            : "translate3d(0, 0px, 0) scale3d(1.2, 1.2, 1)",
      }),
      animate: (i) => ({
          opacity: 1,
          transform: "translate3d(0, 0px, 0) scale3d(1, 1, 1)",
          transition: {
              duration: 1.25,
              delay: i[1] ? i[2] ? 0.35 : 0.75 : 0,
              ease: [0.16, 1, 0.3, 1],
              opacity:{
                duration: i[1] ? 0.75 : 0.5,
                delay: i[2] ? i[1] ? 0.1 : 0 : i[1] ? 0.5 : 0,
                ease: [.79,0,.46,1]
              }
          }
      }),
      exit: {
          opacity: 0,
          transition: {
              duration: 0.65,
              ease: [0.33, 1, 0.68, 1]
          }
      }
}

const ProgressiveGalleryImage = ({ children, placeholderSrc, src, idx, w=100, forceMaxHeight=false, startInvisible, isMobile, scrollInOnLoad = true, overrideObserver = false, noEffects=false}) => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: '0px 0px 0px 0px',
        threshold: 0
    });

    const [isLoaded, setIsLoaded] = useState(false)
    const [aspectRatio, setAspectRatio] = useState(null);
    const [isVisibleOnLoad, setIsVisibleOnLoad] = useState(null);

    useEffect(() => {
            if(document.documentElement.scrollTop< 1 && idx==0){
                setIsVisibleOnLoad(true);
            }
            else{setIsVisibleOnLoad(false);}
    }, [inView])

    useEffect(() =>{
        const img = new Image();
        img.src = placeholderSrc;

        img.onload = () => {
        const ratio = img.naturalWidth / img.naturalHeight;
            setAspectRatio(ratio);
        };

        img.onerror = (err) => {
            console.error('Failed to load image:', err);
        };

        // Cleanup the image object after component unmounts
        return () => {
        setAspectRatio(null);
        };
    }, [])

    return (
        <div 
            ref={ref}
            className="prog-img__wrapper"
            style={{
                height: forceMaxHeight ? "100%" : null,
                minHeight: "100px"
            }}
        >
            { isVisibleOnLoad !== null &&
                <motion.div
                    initial="initial"
                    animate={inView ? "animate" : "initial"}
                    exit="exit"
                    variants={imgWrapperVariants}
                    custom={[startInvisible, isVisibleOnLoad, isMobile, scrollInOnLoad, noEffects]}
                    style={{
                        height: forceMaxHeight ? "100%" : null,
                        width: "100%"
                    }}
                >
                    {children}
                    { aspectRatio &&
                        <motion.div 
                            initial="intial"
                            animate="animate"
                            variants={placeholderVariants}
                            style={{
                                position: "relative",
                                paddingTop: !forceMaxHeight ? 100/aspectRatio+"%" : null,
                                height: forceMaxHeight ? "100%" : "auto",
                                top: 0,
                                left: 0,
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover",
                                width: w+"%",                        
                                backgroundImage: 'url('.concat(placeholderSrc,')')
                            }}
                        />
                    }
                    {
                        (inView) && 
                        <motion.img
                            // key={placeholderSrc+isLoaded}
                            className={"full-gal-img isL-" + isLoaded}
                            initial="intial"
                            animate={isLoaded || noEffects ? "animate" : "initial"}
                            variants={fullImgVariants}
                            onLoad={(e) => {
                                setIsLoaded(true);
                            }}
                            style={{
                                position: 'absolute',
                                width: w+"%",
                                height: forceMaxHeight ? "100%" : "auto",
                                objectFit: forceMaxHeight ? "cover" : null,
                                top: 0,
                                left: 0,
                            }}
                            src={src}
                        />
                    }
                </motion.div>
            }
        </div>

    );
  };
  export default ProgressiveGalleryImage;